<template>
  <form class="p-8 rounded bg-white mt-12 space-y-8 divide-y divide-gray-200">
    <div class="space-y-8 divide-y divide-gray-200 sm:space-y-5">
      <div>
        <div>
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            Add a review
          </h3>
          <p class="mt-1 max-w-2xl text-sm text-gray-500">
            This information will be displayed publicly so be careful what you
            share.
          </p>
        </div>

        <small v-if="listing">
          Listing Id: <b> {{ listing.ListingKeyNumeric }} </b>
        </small>

        <div class="mt-6 sm:mt-5 space-y-6 sm:space-y-5">
          <div
            class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
          >
            <label
              for="first-name"
              class="block text-sm font-medium text-gray-700"
            >
              Who provided the review:
            </label>
            <div class="mt-1">
              <input
                type="text"
                v-model="name"
                class="p-2 shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md"
              />
            </div>
          </div>

          <div
            class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
          >
            <label
              for="about"
              class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
            >
              Paste the review here
            </label>
            <div class="mt-1 sm:mt-0 sm:col-span-2">
              <textarea
                id="about"
                v-model="content"
                name="about"
                rows="5"
                class="p-2 max-w-lg shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md"
              ></textarea>
              <p class="mt-2 text-sm text-gray-500">
                Write a few sentences about yourself.
              </p>
            </div>
          </div>
          <template v-if="hide"></template>
          <template v-else>
            <div class="flex items-center">
              <button
                @click="showAdd = !showAdd"
                type="button"
                :class="spanClass"
                class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <span
                  aria-hidden="true"
                  :class="classSpan"
                  class="pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                ></span>
              </button>
              <span class="ml-3" id="annual-billing-label">
                <span class="text-sm font-medium text-gray-900">Add Image</span>
                <span class="text-sm text-gray-500"
                  >(including address and square)</span
                >
              </span>
            </div>

            <template v-if="showAdd">
              <template v-if="uploadedImg">
                <img
                  class="w-1/4 overflow-hidden bg-gray-100"
                  :src="uploadedImg"
                />
              </template>
              <div
                class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
              >
                <label
                  for="cover-photo"
                  class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
                >
                  Property Image
                </label>
                <div class="mt-1 sm:mt-0 sm:col-span-2">
                  <div
                    class="max-w-lg flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md"
                  >
                    <div class="space-y-1 text-center">
                      <svg
                        class="mx-auto h-12 w-12 text-gray-400"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                        aria-hidden="true"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      <div class="flex text-sm text-gray-600">
                        <label
                          for="file-upload-2"
                          class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                        >
                          <span>Upload a file</span>
                          <input
                            accept="image/png, image/jpeg"
                            @change="uploapMedias"
                            id="file-upload-2"
                            type="file"
                            class="sr-only"
                          />
                        </label>
                        <p class="pl-1">or drag and drop</p>
                      </div>
                      <p class="text-xs text-gray-500">
                        PNG, JPG, GIF up to 10MB
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
              >
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  Street address
                </label>
                <div class="mt-1">
                  <input
                    v-model="address"
                    type="text"
                    class="p-2 shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md"
                  />
                </div>
              </div>

              <div
                class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
              >
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  Square Feet
                </label>
                <div class="mt-1">
                  <input
                    v-model="square"
                    type="text"
                    class="p-2 shadow-sm block w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border border-gray-300 rounded-md"
                  />
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>

      <div class="pt-5">
        <div class="flex justify-end">
          <button
            @click="closeModal()"
            type="button"
            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Cancel
          </button>
          <button
            @click.prevent="saveReview()"
            class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import Swal from "sweetalert2";
export default {
  props: ["listing", "hide"],
  data() {
    return {
      showAdd: false,
      name: "",
      content: "",
      address: "",
      square: "",
      mediaFile: [],
      uploadedImg: ""
    };
  },

  created() {},

  computed: {
    spanClass() {
      if (!this.showAdd) {
        return "bg-gray-200";
      } else {
        return "bg-indigo-600";
      }
    },

    classSpan() {
      if (!this.showAdd) {
        return "translate-x-0";
      } else {
        return "translate-x-5";
      }
    }
  },

  methods: {
    uploapMedias(e) {
      this.mediaFile = e.target.files || e.dataTransfer.files;

      const file = e.target.files[0];
      this.uploadedImg = URL.createObjectURL(file);
    },

    saveReview() {
      var config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      let filesImages = new FormData();
      $.each(this.mediaFile, function(key, image) {
        filesImages.append(`images[${key}]`, image);
      });

      if (this.listing) {
        filesImages.append("listingId", this.listing.ListingKeyNumeric);
        filesImages.append("imageUrl", this.listing.Images[0]);
      }

      filesImages.append("name", this.name);
      filesImages.append("content", this.content);
      filesImages.append("address", this.address);
      filesImages.append("square", this.square);

      // filesImages.append("listingId", id);
      window.axios.post("/api/createReview", filesImages, config).then(() => {
        this.closeModal();
        Swal.fire({
          icon: "success",
          title: "Review successfully added"
        });
      });
    },

    closeModal() {
      this.$emit("clicked");
    }
  }
};
</script>
